import useLocalStorage from "../../../hooks/useLocalStorage";
import { useState, useEffect } from "react";

export default function CookieBanner() {
    const [isVisible, setIsVisible] = useLocalStorage("cookieBannerVisible", true);

    const handleClose = () => {
        setIsVisible(false);
    };

    useEffect(() => {
        if (!isVisible) {
            console.log("Cookie banner dismissed.");
        }
    }, [isVisible]);

    if (!isVisible) return null;

    return (
        <div style={{ zIndex: 9999 }} className="fixed bottom-0 z-60 inset-x-0">
            <div className="p-4 sm:p-6 bg-white border border-gray-200 shadow-2xs dark:bg-neutral-900 dark:border-neutral-800">
                <div className="max-w-[85rem] mx-auto">
                    <div className="grid lg:grid-cols-4 items-center">

                        <div className="lg:col-span-3">
                            <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
                                Whistleblower Policy
                            </h2>
                            <p className="mt-2 text-sm text-gray-600 dark:text-neutral-400">
                               At WITS (Wildlife Incident Tracking System), we are deeply committed to protecting the identities and
security of all individuals who report incidents through our platform. To ensure your safety, we have a
comprehensive Whistleblower Protection Policy in place.
All reports—whether submitted through our mobile app, web portal, or community partners—are treated
with the strictest confidentiality. You may report anonymously, and under no circumstances will your
identity be shared without your explicit consent.
Our Whistleblower Policy guarantees:
● Confidential handling of all incident data
● Protection from retaliation or harm
● Optional anonymous reporting
● Secure, encrypted data systems

We believe that safe, open reporting is essential to uncovering the truth, protecting biodiversity, and
holding wildlife criminals accountable. Your voice matters—and WITS ensures it is heard safely.
<strong>Report with confidence. Protect with courage.</strong>
                            </p>

                        </div>

                        <div className="col-span-full col-start-2 xl:col-start-5 xl:col-span-1">
                            <div className="grid sm:grid-cols-3 xl:grid-cols-1 gap-y-2 sm:gap-y-0 sm:gap-x-5 xl:gap-y-2 xl:gap-x-0">
                                <button onClick={handleClose} type="button" className="py-2 px-3 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-hidden focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none">
                                    Got It
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
